<template>
  <v-container fluid class="pt">
    <form-dialog
      v-model="dialog"
      :title="branch.id ? $t('edit_record') : $t('new_record')"
    >
      <new-branch v-model="branch" @saved="save" />
    </form-dialog>
    <v-layout row wrap>
      <v-card class="elevation-0 shadow-md white mt-2 flex xs12">
        <v-card-text class="pt-3">
          <div class="di-flex flex align-center mb-3">
            <template v-if="can.add">
              <v-btn
                color="primary"
                @click="showDialog"
                v-if="$vuetify.breakpoint.mdAndUp"
              >
                <v-icon class="mx-2">add_circle</v-icon>
                <span class="mt-1">
                  {{ $t("new_record") }}
                </span>
              </v-btn>
              <v-btn
                icon
                flat
                v-else
                class="mx-0"
                color="primary"
                @click="showDialog"
              >
                <v-icon>add_circle</v-icon>
              </v-btn>
            </template>
            <v-spacer />

            <v-text-field
              outline
              hide-details
              v-model="search"
              style="max-width: 400px"
              class="flex xs12 rounded"
              :placeholder="$t('search')"
              prepend-inner-icon="search"
            />
            <v-btn
              flat
              icon
              class="mx-0"
              color="grey darken-2"
              @click="printTable(false)"
            >
              <v-icon>print</v-icon>
            </v-btn>
            <v-btn
              flat
              icon
              class="mx-0"
              color="grey darken-2"
              @click="printTable(true)"
            >
              <v-icon>file_download</v-icon>
            </v-btn>
            <v-btn
              flat
              icon
              class="mx-0"
              @click="getData"
              :loading="loading"
              color="grey darken-2"
            >
              <v-icon>refresh</v-icon>
            </v-btn>
          </div>
          <v-data-table
            ref="tbl"
            item-key="id"
            :items="items"
            class="flex xs12"
            :loading="loading"
            :headers="headers"
            v-model="selected"
            :total-items="meta.total"
            :pagination.sync="pagination"
            :rows-per-page-items="per_page"
          >
            <template slot="items" slot-scope="{ item, index }">
              <tr>
                <td>{{ index + 1 }}</td>
                <td>{{ item.code }}</td>
                <td>
                  <span v-if="item.branch_id == userBranch.id">
                    {{ `${item.name} ` }}
                  </span>
                  <router-link
                    v-else
                    :to="`${type}s/${item.id}?type=${type}`"
                    >{{ `${item.name} ` }}</router-link
                  >
                </td>
                <td>{{ item.pretty_phone }}</td>
                <td>{{ item.address }}</td>
                <td v-if="can.any">
                  <v-btn
                    flat
                    icon
                    small
                    class="ma-0"
                    v-if="can.view && item.branch_id != userBranch.id"
                    color="grey darken-1"
                    @click="$router.push(`${type}s/${item.id}?type=${type}`)"
                  >
                    <v-icon>launch</v-icon>
                  </v-btn>

                  <v-btn
                    icon
                    flat
                    class="ma-0"
                    v-if="
                      can.edit &&
                      (item.branch_id != userBranch.id || userBranch.id == 1)
                    "
                    color="grey darken-1"
                    @click="editItem(item, index)"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <!-- <v-btn
                    icon
                    flat
                    small
                    class="ma-0"
                    color="grey darken-1"
                    @click="deleteItem(item)"
                    v-if="can.delete && type != 'customer'"
                  >
                    <v-icon>delete_outline</v-icon>
                  </v-btn> -->
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import newBranch from "./newBranch.vue";
import debounce from "@/plugins/vDebounce";
import { customersMixin } from "@/mixins/index.js";

export default {
  name: "branches",
  mixins: [customersMixin],
  components: { newBranch },
  data() {
    return {
      type: "branch",
      items: [],
      search: "",
      selected: [],
      dialog: false,
      loading: false,
      meta: {
        total: 0,
        perPage: 0,
        current_page: 0,
      },
      branch: {},
      totalRows: 0,
      loading: true,
      editedIndex: -1,
      pagination: { page: 1, rowsPerPage: 50 },
    };
  },

  computed: {
    can() {
      return {
        add: this.userCan(`add_${this.type}s`),
        view: this.userCan(`view_${this.type}s`),
        edit: this.userCan(`edit_${this.type}s`),
        delete: this.userCan(`delete_${this.type}s`),
        any:
          this.userCan(`edit_${this.type}s`) ||
          this.userCan(`view_${this.type}s`) ||
          this.userCan(`delete_${this.type}s`),
      };
    },

    currencies() {
      return this.initialData.currencies;
    },

    headers: (vm) => {
      let items = [
        {
          value: "index",
          width: "100px",
          sortable: false,
          text: vm.$t("number"),
        },
        {
          value: "id",
          sortable: false,
          text: vm.$t("code"),
        },
        {
          value: "name",
          sortable: false,
          text: vm.$t("name"),
        },
        {
          sortable: false,
          value: "pretty_phone",
          text: vm.$t("phones"),
        },
        {
          value: "address",
          sortable: false,
          text: vm.$t("address"),
        },
      ];
      items.push({
        sortable: false,
        value: "actions",
        text: vm.$t("actions"),
      });
      return items;
    },
  },

  methods: {
    getData() {
      this.loading = true;
      let { search } = this;
      const { page, rowsPerPage } = this.pagination;
      let params = {
        page,
        search,
        type: "branch",
        per_page: rowsPerPage,
      };
      this.axios
        .get(`customers`, { params })
        .then((resp) => {
          this.items = resp.data.data;
          this.meta = resp.data.meta;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    editItem(item, index) {
      this.branch = { ...item.branch };
      this.editedIndex = index;
      this.dialog = true;
    },

    deleteItem(item) {
      let vm = this;
      this.$alert("branches/" + item.branch.id).then(() => {
        vm.items.splice(vm.items.indexOf(item), 1); // remove items
      });
    },

    reset() {
      this.dialog = false;
      this.branch = {
        name: "",
        phones: "",
        address: "",
        type: this.type,
        last_form_number: 100,
        is_bank: this.is_bank,
        organization_chart: require("@/assets/images/orgchart.png"),
      };
      this.editedIndex = -1;
    },

    showDialog() {
      this.reset();
      this.dialog = true;
    },

    save(branch) {
      this.getData();
      this.reset();
    },

    printTable(excel) {
      let data = {
        landscape: false,
        title: this.$t(`${this.type}s`),
        headers: this.headers.slice(1, -1),
        items: this.$refs.tbl.filteredItems,
      };

      if (excel) return this.xl_tables(data, "branches", this.LONG_APP_NAME);
      this.$store.commit("ReportsModule/setTableData", data);
      this.$router.push("/print");
    },
  },

  created() {
    this.reset();
  },

  watch: {
    pagination: {
      handler() {
        this.getData();
      },
      deep: true,
    },

    search: debounce(function (newVal) {
      this.getData(newVal);
    }, 1000),
  },
};
</script>